import Modal from "react-bootstrap/Modal";

const CommentModal = ({ show, handleClose, selectedItem }) => {
    return (
        <Modal show={show} size="md" centered onHide={handleClose} contentClassName="bi-modal">
            <Modal.Header closeButton>
                <Modal.Title>Comments</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {selectedItem && (
                    <>
                        <div className="bi-modal-block">
                          <p className="bi-modal-label">Member Comment</p>
                          <p className="bi-modal-text">
                            {selectedItem.member_comment || <em>No comment from member.</em>}
                          </p>
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default CommentModal;
